<!-- 案件検索 -->
<div class="search-box" *ngIf="searchSide === 'project'; else searchWorker">
  <div class="sub-panel-header">
    <p></p>
    <app-search-action [searchService]="searchService" [searchParams]="searchParams"></app-search-action>
  </div>
  <form>
    <app-search-items [searchParams]="searchParams" [allSkills]="searchService.allSkills" [page]="page"
      [forWorker]="false" (searchParamsChange)="doSearch()" [open]="open"></app-search-items>
  </form>
</div>

<!-- 人材検索 -->
<ng-template #searchWorker>
  <div class="search-box">
    <div class="sub-panel-header">
      <p></p>
      <app-search-action [searchService]="searchService" [searchParams]="searchParams"></app-search-action>
    </div>
    <form>
      <app-search-items [searchParams]="searchParams" [allSkills]="searchService.allSkills" [page]="page"
        [forWorker]="true" (searchParamsChange)="doSearch()" [open]="open"></app-search-items>
    </form>
  </div>
</ng-template>